import actionType from "../actionTypes";

const reducerName = actionType.reduxUpdateLearningPlansState;
const base = "/api/learning/plans";

const req =
  (actionKey, method, urlOrFn) => (componentRequest) => (dispatch) => {
    const url = typeof urlOrFn === "function" ? urlOrFn(componentRequest) : urlOrFn;
    global.api.requestAPI({
      axiosParams: { method, url },
      actionType: actionKey,
      reducerName,
      dispatch,
      componentRequest,
    });
  };

export default {
  list: req(actionType.learning_plans.list, "get", base),
  get: req(actionType.learning_plans.get, "get", (cr) => `${base}/${encodeURIComponent(cr.params.id)}`),
  create: req(actionType.learning_plans.create, "post", base),
  update: req(
    actionType.learning_plans.update,
    "patch",
    (cr) => `${base}/${encodeURIComponent(cr.params.id)}`
  ),
  remove: req(
    actionType.learning_plans.remove,
    "delete",
    (cr) => `${base}/${encodeURIComponent(cr.params.id)}`
  ),
  generate: req(actionType.learning_plans.generate, "post", `${base}/generate`),
  forPlayer: req(
    actionType.learning_plans.forPlayer,
    "get",
    (cr) => `${base}/player/${encodeURIComponent(cr.params.playerId)}`
  ),
};
